import React from 'react';
import { IPublication, PublicationType } from '../Models';
import { DateHelper } from '../Helpers/DateHelper';

function getExtension(uri: string) {
    const extension = uri.split('.').pop();

    return extension ? extension.split(/\#|\?/)[0] : '';
}

function getIconClassName(content: IPublication): string {
    switch (content.type) {
        case PublicationType.Spreadsheet:
            return 'icon-xls';

        case PublicationType.Image:
            // eslint-disable-next-line no-case-declarations
            const extension = getExtension(content.linkUri);
            switch (extension) {
                case 'jpg':
                case 'jpeg':
                    return 'icon-jpg';

                case 'png':
                    return 'icon-png';

                default:
                    return 'icon-download';
            }

        case PublicationType.Pdf:
            return 'icon-pdf';

        case PublicationType.Document:
            return 'icon-doc';

        default:
            return 'icon-download';
    }
}

interface IPublicationLinkProps extends IPublication {
    themes: string[];
}

export function PublicationLink(content: IPublicationLinkProps) {
    const description = document.createElement('DIV');
    description.innerHTML = content.description;

    return (
        <article className="tile tile--with-icon">
            <div className="tile-icon">
                {content.imageLink ? (
                    <img src={content.imageLink} />
                ) : (
                    <i className={getIconClassName(content)}></i>
                )}
            </div>
            <div className="tile-content">
                <a
                    href={content.linkUri}
                    className="document-link"
                    target="_blank"
                    rel="noreferrer"
                >
                    <h4 className="secondary-text-color">{content.title}</h4>
                </a>
                <div className="details">
                    <span>
                        {DateHelper.ToDateLocalString(
                            content.date,
                            document.querySelector('html')!.lang
                        )}
                    </span>
                    <i className="icon-point"></i>
                    {content.themes &&
                        content.themes.map((theme, index) => {
                            return (
                                <div key={index}>
                                    <span>{theme}</span>
                                    <i className="icon-point"></i>
                                </div>
                            );
                        })}
                    <span className="document-information">
                        {getExtension(content.linkUri)} (
                        {Math.floor(content.size / 102.4) / 10}ko)
                    </span>
                </div>
                {content.description && (
                    <p className="additional-content">
                        {description.innerText}
                    </p>
                )}
            </div>
        </article>
    );
}
